import { Switch } from "@mantine/core";
import React, { useState } from "react";
import { SearchFilters } from "src/model/SearchFilters";
import AdvancedSearch from "./AdvancedSearch";
import SimpleSearch from "./SimpleSearch";

export default function SearchWrapper(props: {
  onSubmit(searchFilters: SearchFilters): void;
}) {
  const [isAdvancedSearchEnabled, setIsAdvancedSearchEnabled] = useState(false);

  return (
    <div className="flex flex-col w-full h-full xs:p-8 gap-4">
      {/* <div className="flex flex-row gap-2 items-center justify-end m-4 mb-0">
        <Switch
          size="xs"
          className="cursor-pointer"
          label="Advanced search"
          defaultChecked={isAdvancedSearchEnabled}
          checked={isAdvancedSearchEnabled}
          onChange={(event) =>
            setIsAdvancedSearchEnabled(event.currentTarget.checked)
          }
        />
      </div> */}
      <div className="flex flex-col w-full h-full">
        {isAdvancedSearchEnabled ? (
          <AdvancedSearch onSubmit={props.onSubmit} />
        ) : (
          <SimpleSearch onSubmit={props.onSubmit} />
        )}
      </div>
    </div>
  );
}
